/* ==========================================================================
   LABENG — JavaScript du thème (sans dépendance)
   - favoris (localStorage) + page « Mes favoris »
   - bannière vidéo : pause / lecture
   - menus déroulants (fermeture au clic extérieur et à Échap)
   - fiche produit : choix de variante, ajout au panier sans rechargement
   - panier : changement de quantité
   - filtres de collection : envoi automatique
   - produits associés
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var STORAGE_KEY = 'labeng:favorites';

  function qs(selector, context) { return (context || document).querySelector(selector); }
  function qsa(selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(T.locale || 'fr', { style: 'currency', currency: T.currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (T.currency || '');
    }
  }

  /* ------------------------------------------------------------------ */
  /* Favoris                                                             */
  /* ------------------------------------------------------------------ */

  var favorites = {
    read: function () {
      try {
        var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        return Array.isArray(value) ? value : [];
      } catch (e) {
        return [];
      }
    },
    write: function (list) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) { /* navigation privée : ignoré */ }
      document.dispatchEvent(new CustomEvent('favorites:change', { detail: list }));
    },
    has: function (handle) { return favorites.read().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var list = favorites.read();
      var index = list.indexOf(handle);
      if (index === -1) { list.push(handle); } else { list.splice(index, 1); }
      favorites.write(list);
    }
  };

  function syncFavoriteButtons(root) {
    qsa('[data-favorite-toggle]', root).forEach(function (button) {
      var active = favorites.has(button.getAttribute('data-product-handle'));
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? button.getAttribute('data-label-remove') : button.getAttribute('data-label-add'));
    });
  }

  function updateFavoriteCount() {
    var count = favorites.read().length;
    qsa('[data-favorites-count]').forEach(function (node) {
      node.textContent = '(' + count + ')';
      node.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-favorite-toggle]');
    if (!button) { return; }
    event.preventDefault();
    favorites.toggle(button.getAttribute('data-product-handle'));
  });

  document.addEventListener('favorites:change', function () {
    syncFavoriteButtons(document);
    updateFavoriteCount();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      syncFavoriteButtons(document);
      updateFavoriteCount();
      document.dispatchEvent(new CustomEvent('favorites:change'));
    }
  });

  /* Page « Mes favoris » : récupère chaque produit via /products/handle.js */
  var favoriteProducts = {};

  function favoriteCard(product, ratio) {
    var url = product.featured_image || '';
    var src = url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=700' : '';
    var image = src
      ? '<img class="product-card__image" loading="lazy" width="700" height="700" src="' + esc(src) + '" alt="' + esc(product.title) + '">'
      : '';
    var nameMain = product.title;
    var nameSub = '';
    var quoted = /^(.*?)«\s*(.*?)\s*»/.exec(product.title);
    if (quoted) { nameMain = quoted[2]; nameSub = quoted[1].trim(); }
    var sold = product.available ? '' : '<span class="badge badge--sold">' + esc(T.strings.soldOut) + '</span>';
    return '<li><article class="product-card' + (product.available ? '' : ' product-card--sold-out') + '">' +
      '<div class="product-card__media product-card__media--' + esc(ratio) + '">' + image + sold +
      '<button type="button" class="favorite-button" data-favorite-toggle data-product-handle="' + esc(product.handle) + '" aria-pressed="true"' +
      ' aria-label="' + esc(T.strings.favoriteRemove) + '" data-label-add="' + esc(T.strings.favoriteAdd) + '" data-label-remove="' + esc(T.strings.favoriteRemove) + '">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10A4.5 4.5 0 0 1 12 7.6a4.5 4.5 0 0 1 7.5 2.9c0 5.4-7.5 10-7.5 10z"/></svg>' +
      '</button></div>' +
      '<div class="product-card__info">' +
      '<h3 class="product-card__name"><a class="product-card__link" href="' + esc(product.url) + '">' + esc(nameMain) + '</a></h3>' +
      (nameSub ? '<p class="product-card__title">' + esc(nameSub) + '</p>' : '') +
      '<div class="price"><span class="price__current">' + esc(money(product.price)) + '</span></div>' +
      '</div></article></li>';
  }

  function loadFavoriteProduct(handle) {
    if (favoriteProducts[handle]) { return Promise.resolve(favoriteProducts[handle]); }
    return fetch(T.routes.products + encodeURIComponent(handle) + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (product) { favoriteProducts[handle] = product; }
        return product;
      })
      .catch(function () { return null; });
  }

  function initFavoritesPage(root) {
    qsa('[data-favorites-page]', root).forEach(function (page) {
      if (page.getAttribute('data-ready')) { return; }
      page.setAttribute('data-ready', 'true');
      var list = qs('[data-favorites-list]', page);
      var empty = qs('[data-favorites-empty]', page);
      var ratio = page.getAttribute('data-ratio') || 'square';

      function render() {
        var handles = favorites.read();
        if (!handles.length) {
          list.innerHTML = '';
          empty.hidden = false;
          return;
        }
        Promise.all(handles.map(loadFavoriteProduct)).then(function (products) {
          var found = products.filter(Boolean);
          list.innerHTML = found.map(function (product) { return favoriteCard(product, ratio); }).join('');
          empty.hidden = found.length > 0;
        });
      }

      document.addEventListener('favorites:change', render);
      render();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Bannière vidéo                                                      */
  /* ------------------------------------------------------------------ */

  function initHero(root) {
    qsa('[data-hero]', root).forEach(function (hero) {
      if (hero.getAttribute('data-ready')) { return; }
      hero.setAttribute('data-ready', 'true');

      var video = qs('video', hero);
      var toggle = qs('[data-hero-toggle]', hero);
      if (!video) { return; }

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
      }

      function refresh() {
        if (!toggle) { return; }
        var paused = video.paused;
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', paused ? T.strings.play : T.strings.pause);
      }

      video.addEventListener('play', refresh);
      video.addEventListener('pause', refresh);
      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) { video.play(); } else { video.pause(); }
        });
      }
      refresh();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Menus déroulants                                                    */
  /* ------------------------------------------------------------------ */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') { return; }
    qsa('details[data-closable][open]').forEach(function (details) { details.removeAttribute('open'); });
  });

  document.addEventListener('click', function (event) {
    qsa('details[data-closable][open]').forEach(function (details) {
      if (!details.contains(event.target)) { details.removeAttribute('open'); }
    });
  });

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (details.matches && details.matches('details[data-focus-input][open]')) {
      var input = qs('input', details);
      if (input) { input.focus(); }
    }
  }, true);

  /* ------------------------------------------------------------------ */
  /* Panier                                                              */
  /* ------------------------------------------------------------------ */

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (node) { node.textContent = '(' + count + ')'; });
  }

  function initCart(root) {
    qsa('[data-cart-qty]', root).forEach(function (input) {
      if (input.getAttribute('data-ready')) { return; }
      input.setAttribute('data-ready', 'true');
      input.addEventListener('change', function () {
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        input.disabled = true;
        fetch(T.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(input.getAttribute('data-line'), 10), quantity: quantity })
        }).then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Fiche produit                                                       */
  /* ------------------------------------------------------------------ */

  function initProduct(root) {
    qsa('[data-product]', root).forEach(function (product) {
      if (product.getAttribute('data-ready')) { return; }
      product.setAttribute('data-ready', 'true');

      var form = qs('[data-product-form]', product);
      var variantsNode = qs('[data-variants]', product);
      if (!form || !variantsNode) { return; }

      var variants = [];
      try { variants = JSON.parse(variantsNode.textContent); } catch (e) { variants = []; }

      var idInput = qs('[data-variant-id]', form);
      var button = qs('[data-add-button]', form);
      var buttonLabel = qs('[data-add-label]', form);
      var priceNode = qs('[data-price]', product);
      var message = qs('[data-product-message]', product);
      var groups = qsa('[data-option-group]', product);

      function selectedValues() {
        return groups.map(function (group) {
          var checked = qs('input:checked', group);
          return checked ? checked.value : null;
        });
      }

      function matches(variant, values) {
        return values.every(function (value, index) {
          return value === null || variant['option' + (index + 1)] === value;
        });
      }

      function findVariant(values) {
        return variants.filter(function (variant) { return matches(variant, values); })[0];
      }

      function markAvailability(values) {
        groups.forEach(function (group, groupIndex) {
          qsa('input', group).forEach(function (input) {
            var test = values.slice();
            test[groupIndex] = input.value;
            var available = variants.some(function (variant) { return variant.available && matches(variant, test); });
            input.setAttribute('data-unavailable', available ? 'false' : 'true');
          });
        });
      }

      function priceHtml(variant) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          return '<div class="price price--sale"><s class="price__compare">' + esc(money(variant.compare_at_price)) +
            '</s><span class="price__current">' + esc(money(variant.price)) + '</span></div>';
        }
        return '<div class="price"><span class="price__current">' + esc(money(variant.price)) + '</span></div>';
      }

      function setButton(state) {
        if (!button) { return; }
        var labels = {
          add: button.getAttribute('data-label-add') || T.strings.addToCart,
          sold: button.getAttribute('data-label-sold') || T.strings.soldOut,
          unavailable: button.getAttribute('data-label-unavailable') || T.strings.unavailable
        };
        button.disabled = state !== 'add';
        if (buttonLabel) { buttonLabel.textContent = labels[state]; }
      }

      function updateColorNames() {
        groups.forEach(function (group) {
          var nameNode = qs('[data-selected-name]', group);
          var checked = qs('input:checked', group);
          if (nameNode && checked) { nameNode.textContent = checked.value; }
        });
      }

      function update() {
        var values = selectedValues();
        updateColorNames();
        markAvailability(values);
        var variant = findVariant(values);

        if (!variant) {
          setButton('unavailable');
          return;
        }

        if (idInput) { idInput.value = variant.id; }
        if (priceNode) { priceNode.innerHTML = priceHtml(variant); }
        setButton(variant.available ? 'add' : 'sold');

        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + '?variant=' + variant.id);
        }

        var mediaId = variant.featured_media && variant.featured_media.id;
        if (mediaId) {
          var media = qs('[data-media-id="' + mediaId + '"]', product);
          if (media && media.scrollIntoView) {
            media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        }
      }

      groups.forEach(function (group) { group.addEventListener('change', update); });
      markAvailability(selectedValues());

      function say(text, isError) {
        if (!message) { return; }
        message.textContent = text;
        message.classList.toggle('form-message--error', !!isError);
      }

      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData) { return; }
        event.preventDefault();
        if (button && button.disabled) { return; }
        if (button) { button.setAttribute('aria-busy', 'true'); }
        say('', false);

        fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (response) {
          return response.json().then(function (json) { return { ok: response.ok, json: json }; });
        }).then(function (result) {
          if (!result.ok) { throw new Error(result.json.description || result.json.message || T.strings.error); }
          return fetch(T.routes.cartJs).then(function (response) { return response.json(); });
        }).then(function (cart) {
          updateCartCount(cart.item_count);
          say(T.strings.added, false);
        }).catch(function (error) {
          say(error.message || T.strings.error, true);
        }).then(function () {
          if (button) { button.removeAttribute('aria-busy'); }
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Filtres et tri des collections                                      */
  /* ------------------------------------------------------------------ */

  function initFacets(root) {
    qsa('[data-facets-form]', root).forEach(function (form) {
      if (form.getAttribute('data-ready')) { return; }
      form.setAttribute('data-ready', 'true');
      var timer;
      form.addEventListener('change', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { form.submit(); }, 250);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Produits associés (chargés après coup, comme le veut Shopify)       */
  /* ------------------------------------------------------------------ */

  if (window.customElements && !window.customElements.get('product-recommendations')) {
    window.customElements.define('product-recommendations', (function () {
      function Recommendations() { return Reflect.construct(HTMLElement, [], Recommendations); }
      Recommendations.prototype = Object.create(HTMLElement.prototype);
      Recommendations.prototype.constructor = Recommendations;
      Object.setPrototypeOf(Recommendations, HTMLElement);
      Recommendations.prototype.connectedCallback = function () {
        var host = this;
        var url = host.getAttribute('data-url');
        if (!url) { return; }
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var holder = document.createElement('div');
            holder.innerHTML = text;
            var source = qs('product-recommendations', holder);
            var section = host.closest('[data-recommendations-section]');
            if (source && source.innerHTML.trim().length) {
              host.innerHTML = source.innerHTML;
              syncFavoriteButtons(host);
              if (section) { section.hidden = false; }
            } else if (section) {
              section.hidden = true;
            }
          })
          .catch(function () { /* silencieux : la section reste vide */ });
      };
      return Recommendations;
    })());
  }

  /* ------------------------------------------------------------------ */
  /* Ajout rapide au panier depuis les cartes produit                    */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-quick-add]') : null;
    if (!button || button.disabled || !window.fetch) { return; }
    event.preventDefault();
    event.stopPropagation();
    if (button.getAttribute('aria-busy') === 'true') { return; }
    button.setAttribute('aria-busy', 'true');

    var panel = button.closest('.quick-add');
    var title = panel ? qs('[data-quick-add-title]', panel) : null;
    var original = title ? title.textContent : button.textContent;
    function say(text) {
      if (title) { title.textContent = text; } else { button.textContent = text; }
      window.setTimeout(function () {
        if (title) { title.textContent = original; } else { button.textContent = original; }
      }, 2200);
    }

    fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }] })
    }).then(function (response) {
      return response.json().then(function (json) { return { ok: response.ok, json: json }; });
    }).then(function (result) {
      if (!result.ok) { throw new Error(result.json.description || result.json.message || T.strings.error); }
      return fetch(T.routes.cartJs).then(function (response) { return response.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      say(T.strings.added);
    }).catch(function (error) {
      say(error.message || T.strings.error);
    }).then(function () {
      button.removeAttribute('aria-busy');
    });
  });

  /* Choix de la couleur sur une carte produit (produits dont la seule option est la couleur) */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest ? event.target.closest('[data-swatch-select]') : null;
    if (!swatch) { return; }
    event.preventDefault();
    var card = swatch.closest('.product-card');
    if (!card) { return; }
    qsa('[data-swatch-select]', card).forEach(function (node) {
      node.setAttribute('aria-pressed', node === swatch ? 'true' : 'false');
    });
    var index = Number(swatch.getAttribute('data-index')) || 0;
    qsa('[data-quick-add][data-map]', card).forEach(function (button) {
      var entry = (button.getAttribute('data-map').split('|')[index] || ':').split(':');
      if (entry[0]) { button.setAttribute('data-variant-id', entry[0]); }
      if (entry[0] && entry[1] === 'true') { button.removeAttribute('disabled'); }
      else { button.setAttribute('disabled', 'disabled'); }
    });
    var image = swatch.getAttribute('data-image');
    var photo = qs('.product-card__image:not(.product-card__image--hover)', card);
    if (image && photo) {
      photo.removeAttribute('srcset');
      photo.setAttribute('src', image);
    }
  });

  /* Cartes produit : un clic sur une pastille de couleur liée affiche l'autre produit sur place */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest ? event.target.closest('[data-card-swap]') : null;
    if (!swatch) { return; }
    event.preventDefault();
    var card = swatch.closest('.product-card');
    if (!card) { return; }

    qsa('[data-card-swap]', card).forEach(function (node) {
      node.setAttribute('aria-pressed', node === swatch ? 'true' : 'false');
    });

    var url = swatch.getAttribute('data-url');
    var available = swatch.getAttribute('data-available') === 'true';
    var media = qs('.product-card__media', card);

    // Photos
    var image = swatch.getAttribute('data-image');
    var photo = qs('.product-card__image:not(.product-card__image--hover)', card);
    if (image && photo) { photo.removeAttribute('srcset'); photo.setAttribute('src', image); }
    var hover = qs('.product-card__image--hover', card);
    if (hover) {
      var image2 = swatch.getAttribute('data-image2');
      if (image2) { hover.removeAttribute('srcset'); hover.setAttribute('src', image2); hover.style.display = ''; }
      else { hover.style.display = 'none'; }
    }

    // Textes, lien et prix
    var nameLink = qs('.product-card__name a', card);
    if (nameLink) { nameLink.textContent = swatch.getAttribute('data-name'); nameLink.setAttribute('href', url); }
    var sub = qs('.product-card__title', card);
    var subText = swatch.getAttribute('data-sub');
    if (sub) {
      sub.textContent = subText;
      sub.style.display = subText ? '' : 'none';
    }
    var price = qs('.price', card);
    var priceHtml = swatch.getAttribute('data-price');
    if (price && priceHtml) { price.outerHTML = priceHtml; }

    // Badge (Neuf, Out of stock...)
    var badge = qs('.badge', media);
    var badgeLabel = swatch.getAttribute('data-badge');
    var soldStyle = 'top: 10px; bottom: auto; left: auto; right: 10px; background: #fff; color: var(--color-text);';
    var wanted = !available ? 'Out of stock' : badgeLabel;
    if (wanted) {
      if (!badge && media) {
        badge = document.createElement('span');
        badge.className = 'badge';
        media.appendChild(badge);
      }
      if (badge) {
        badge.textContent = wanted;
        if (!available) { badge.classList.add('badge--sold'); badge.setAttribute('style', soldStyle); }
        else { badge.classList.remove('badge--sold'); badge.removeAttribute('style'); }
      }
    } else if (badge) {
      badge.parentNode.removeChild(badge);
    }
    card.classList.toggle('product-card--sold-out', !available);

    // Ajout rapide
    qsa('[data-quick-add]', card).forEach(function (button) {
      button.setAttribute('data-variant-id', swatch.getAttribute('data-variant-id'));
      if (available) { button.removeAttribute('disabled'); } else { button.setAttribute('disabled', 'disabled'); }
    });
  });

  /* ------------------------------------------------------------------ */
  /* Initialisation                                                      */
  /* ------------------------------------------------------------------ */

  function init(root) {
    syncFavoriteButtons(root);
    initHero(root);
    initProduct(root);
    initCart(root);
    initFacets(root);
    initFavoritesPage(root);
  }

  function ready() {
    init(document);
    updateFavoriteCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  /* Éditeur de thème Shopify : réinitialiser une section quand elle est rechargée */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();